export const getDecimalScale = (currency) => {
    const decimalMap = {
        BTC: 6,   // Bitcoin standard precision
        ETH: 4,   // Ethereum common precision
        USDT: 2,  // Tether (fiat-pegged)
        USD: 2,
        EUR: 2,
        ILS: 2,
        MDL: 2,
        CZK: 2,
        GBP: 2
    };

    return decimalMap[currency] || 2;
};

export const getCurrencyConfig = (currency) => {
    const config = {
        BTC: {
            decimalScale: 6,
            displayDecimals: 6,
            minAmountFormat: (amount) => amount.toFixed(6)
        },
        ETH: {
            decimalScale: 4,
            displayDecimals: 4,
            minAmountFormat: (amount) => amount.toFixed(4)
        },
        USDT: {
            decimalScale: 2,
            displayDecimals: 2,
            minAmountFormat: (amount) => amount.toFixed(2)
        },
        // Add other currencies as needed
        default: {
            decimalScale: 2,
            displayDecimals: 2,
            minAmountFormat: (amount) => amount.toFixed(2)
        }
    };

    return config[currency] || config.default;
};